module.exports = __webpack_public_path__ + "static/media/leave-note.4e9ccba9.svg";